import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { RequirementAction } from "../types";

export const extendRequirementOnboardingToolbarActions = (
  requirement: IRequirementResponse,
  originalActions: RequirementAction[],
  onClose: () => void
): RequirementAction[] => {
  const isIncomplete = requirement.status === RequirementStatus.Incomplete;

  const defaultActions: RequirementAction[] = [
    {
      label: "Continue",
      buttonKind: "Primary",
      visible: !isIncomplete,
      hideButtonOn: [],
      onClick: () => {
        onClose();
      }
    },
    {
      label: "Close",
      buttonKind: "Tertiary",
      visible: isIncomplete,
      hideButtonOn: [],
      onClick: () => {
        onClose();
      }
    }
  ];

  if (
    originalActions.filter(
      action => action.visible !== false && action.hidden !== true
    ).length > 2
  ) {
    const visibleMainButtons = originalActions.map(action => ({
      ...action,
      buttonKind:
        action.mainAction && action.visible !== false && action.hidden !== true
          ? action.buttonKind
          : undefined
    }));

    return [...defaultActions, ...visibleMainButtons];
  }

  return [...defaultActions, ...originalActions];
};
